import React from 'react';

const FilterSuggestion = ({ displayValue, label, prefix }) => (
  <div className="aridhia-filter-suggestion">
    <span className="aridhia-filter-suggestion-label">{label}</span>
    <span className="aridhia-filter-suggestion-prefix">{prefix}</span>
    {displayValue && <span className="aridhia-filter-suggestion-value">{displayValue}</span>}
  </div>
);

export default FilterSuggestion;
